enum ConditionCategory {
    contraindicationPrecaution,
    immunizationProof
}

export { ConditionCategory };
